var React = require('react');

function StarInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.81553 15.8264C3.18461 16.3109 2.29499 15.7041 2.53758 14.9547L7.19844 0.557312C7.43665 -0.178535 8.49389 -0.188196 8.74602 0.54317L13.6652 14.8124C13.9173 15.5436 13.0717 16.1661 12.4271 15.7238L8.44411 12.9903C8.15068 12.7889 7.75767 12.7993 7.47567 13.0158L3.81553 15.8264Z","fill":"#1A1A1A","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.7172 14.8337C13.9675 15.5676 13.1155 16.1875 12.473 15.7391L0.344082 7.27439C-0.30427 6.82191 0.0250237 5.81911 0.82053 5.82346L15.1887 5.90217C15.9866 5.90655 16.3028 6.91787 15.6447 7.36085L12.5108 9.47047C12.2109 9.67238 12.0837 10.045 12.1992 10.3836L13.7172 14.8337Z","fill":"#1A1A1A","key":1})]);
}

StarInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = StarInline;

StarInline.default = StarInline;
